selectEmailsCtrl.$inject = ['domainEmails']

export function selectEmailsCtrl(domainEmails) {
  this.emails = []
  this.unmatchedEmails = []
  this.matchedEmails = []
  this.emailsInput = ''

  const isEmailInDomainList = {}
  if (Array.isArray(domainEmails)) {
    domainEmails.forEach(e => (isEmailInDomainList[e.toLowerCase()] = true))
  }

  this.parseEmails = () => {
    let lines = this.emailsInput.split('\n')
    this.emails = []
    let emailPresent = {}

    // filter out blanks and duplicates
    lines.forEach(line => {
      line = line.toLowerCase().trim()
      if (line === '' || emailPresent[line]) {
        return
      }
      emailPresent[line] = true
      this.emails.push(line)
    })

    validateEmails(this.emails)
  }

  // Sorts the list of emails into 2 lists; one where emails match the provided domainEmails, and the other where there is no match. Expects each email to be lowercased and trimmed.
  // wrap this operation in a promise in case the list is very long
  const validateEmails = emails => {
    this.matchedEmails = []
    this.unmatchedEmails = []
    return new Promise(resolve => {
      emails.forEach(email => {
        if (isEmailInDomainList[email]) {
          this.matchedEmails.push(email)
        } else {
          this.unmatchedEmails.push(email)
        }
      })
      resolve()
    })
  }
}
